import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=14d50a83&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./css/login.css?vue&type=style&index=0&lang=css&"
import style1 from "./ForgottenPassword.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports